import { Controller } from "@hotwired/stimulus";

export default class MediaLoaderController extends Controller {
  connect() {
    this.media = this.element.querySelector("img, video") || this.element;

    if (!this.media) return;

    if (this.media.tagName === "IMG") {
      this.connectImage();
    } else if (this.media.tagName === "VIDEO") {
      this.connectVideo();
    }
  }

  connectImage() {
    // Image already loaded before Stimulus connected
    if (this.media.complete && this.media.naturalWidth > 0) {
      this.loaded();
      return;
    }

    this.media.addEventListener("load", this.loaded);
  }

  connectVideo() {
    // Video already loaded before Stimulus connected
    if (this.media.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA) {
      this.loaded();
      return;
    }

    this.media.addEventListener("loadeddata", this.loaded);
  }

  disconnect() {
    if (!this.media) return;

    this.media.removeEventListener("load", this.loaded);
    this.media.removeEventListener("loadeddata", this.loaded);
  }

  loaded = () => {
    this.element.classList.remove("profile-image-skeleton-dark");
  };
}
